export default "__VITE_ASSET__3b3a3d60__"